const isArrayWithElements = arr => Array.isArray(arr) && arr.length > 0;

/**
 * For most resources, which currently use arrays
 * @param {*} isFieldInvalid
 * @param {*} invalidFieldMessage
 */
const cloneResourceInvalidFieldUIState = (isFieldInvalid, invalidFieldMessage) => {
  const isFieldInvalidCopy = Array.isArray(isFieldInvalid) ? isFieldInvalid.slice() : null;
  const invalidFieldMessageCopy = Array.isArray(invalidFieldMessage) ? invalidFieldMessage.slice() : null;
  return { isFieldInvalidCopy, invalidFieldMessageCopy };
};

/**
 * To check number field, for decimal type, input should be within
 * the range of 0 ~ 999.99, since in database the type is decimal(5,2)
 * For integer, the range is withn 0 ~ 2^31 -1 since the type in database
 * is int(11), which is signed integer but we dont need negative number and
 * no decimal point is allowed, eg. 12 is fine but 12.0 is not allowed.
 */
const validateNumberTypes = (val, field) => {
  const databaseIntLimit = (2 ** 31) - 1;
  const inputNum = Number(val);
  const intRange = inputNum >= 0 && inputNum <= databaseIntLimit;
  const nonZeroIntRange = inputNum > 0 && inputNum <= databaseIntLimit;
  const decimalRange = inputNum >= 0 && inputNum <= 999.99;
  const widthPercentageRange = inputNum >= field.minWidth && inputNum <= field.maxWidth;
  const taxRange = inputNum >= 0 && inputNum <= 100;

  const invalidDecimal = Number.isNaN(inputNum) || /([.][0-9]{3,})/g.test(val) || !decimalRange;
  const invalidInt = !Number.isInteger(inputNum) || /([.])/g.test(val) || !intRange;
  const invalidNonZeroInt = !Number.isInteger(inputNum) || /([.])/g.test(val) || !nonZeroIntRange;
  const invalidWidth = !Number.isInteger(inputNum) || /([.])/g.test(val) || !widthPercentageRange;
  const invalidTax = Number.isNaN(inputNum) || !taxRange;

  return {
    invalidDecimal,
    invalidInt,
    invalidWidth,
    invalidTax,
    invalidNonZeroInt,
  };
};

const getFieldIsInvalidStateKey = key => `${key}IsInvalid`;
const getInvalidFieldMessageStateKey = key => `invalid${key}Message`;

const getErrorMessage = (field, isInvalid) => {
  if (!isInvalid) return '';
  if (field.isRequired) return `${field.title} is required`;
  if (field.type === 'number') return `${field.title} must be a whole number e.g. 1, 2`;
  if (field.type === 'decimal') return `${field.title} should only have two decimal places`;
  if (field.type === 'nonZeroInt') return `${field.title} must be a whole number bigger than zero`;
  return '';
};

const getPositionErrorMessage = (isInvalid, startingPosition) => {
  if (!isInvalid) return '';
  if (startingPosition === 0) return 'Position must be a whole number, e.g. 1, 2.';
  if (startingPosition > 0) return 'Position must be a whole number e.g. 1, 2, and cannot be changed back to zero';
};

/**
 * For some resources,the API will leave the position value in the database alone if you send it 0.
 * Therefore, don't bother the user if they started with 0 as their position, as
 * we don't want to hassle the user to find a good position number to change to.
 * But if they start with a non-zero position, and change it to zero,
 * Get them to change the number, because otherwise submitting it will look like
 * a successful change, but the position will not have updated to 0
 */
const isPositionInvalid = (startingPosition, numberValidations) => {
  return startingPosition === 0 ? numberValidations.invalidInt : numberValidations.invalidNonZeroInt;
};

export {
  cloneResourceInvalidFieldUIState,
  getErrorMessage,
  getFieldIsInvalidStateKey,
  getInvalidFieldMessageStateKey,
  getPositionErrorMessage,
  isArrayWithElements,
  isPositionInvalid,
  validateNumberTypes,
};
